/* @flow */
import Entity from 'lib/Entity';

export default class ReactionEmoji extends Entity {
  getName() {
    return this.get('name');
  }

  getEmojiCode() {
    return `:${this.get('name')}:`; // API returns Emoji shortcodes with no colons
  }
}



// WEBPACK FOOTER //
// ./src/entities/ReactionEmoji.js